import Banner from './Banner'
import IosLimitSetting from './IosLimitSetting'
import Setting from './index'

export default {
  path: '/home/setting',
  component: Setting,
  children: [
    { path: '/home/setting/banner', component: Banner },
    { path: '/home/setting/iosLimitSetting', component: IosLimitSetting },
  ],
}
